<template>
  <div class="component-select-card">
    <auth-button auth="market:coupon:template:create">
      <el-button class="down-btn mr10" @click="onSyncVoucherCenter" :loading="syncVoucherCenteLoading" >拉取中台权益</el-button>
    </auth-button>
    <el-drawer
      :visible="showDrawer"
      direction="rtl"
      size="50%"
      @close="onClose"
    >
      <template slot="title">
        <div style="font-weight: 600; color: #333;">拉取中台权益</div>
      </template>
      <div class="drawer-box">
        <div class="drawer-main-box">
          <div class="table-box">
            <el-table
              :data="tableData"
              style="width: 100%"
              v-loading="loading"
              empty-text="暂无数据"
              @select="selectTable"
              @select-all="selectTable_all"
              :header-cell-style="{ background:'#F2F3F5',height:'50px',border: '0'}"
              :row-key="row => row.refId"
              ref="table"
            >
              <el-table-column type="selection" align="center" width="55" :selectable="onSelectable"></el-table-column>
              <el-table-column prop="thirdId" label="SPUID"></el-table-column>
              <el-table-column prop="name" label="商品名称"></el-table-column>
              <el-table-column prop="channelName" label="渠道"></el-table-column>
              <el-table-column prop="amount" label="面值"></el-table-column>
              <el-table-column prop="sellAmount" label="售价"></el-table-column>
              <el-table-column prop="validTime" label="有效期"></el-table-column>
            </el-table>
          </div>
        </div>
        <div class="footer">
          <el-button @click="onClose" class="mr20">取消</el-button>
          <el-button type="primary" v-if="isSubmit" @click="onSubmit" :loading="submitLoading">提交</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
import { api_getVcCardList, api_getVcCardSync} from '@/api/market'
export default {
  name: "ConponentSelectCard",
  components: {
    Search,
    Table,
    AuthButton
  },
  props: {
    form: {
      type: Object,
      default() {
        return {}
      },
    },
    maxLength: {
      type: Number,
      default() {
        return 0
      },
    }
  },
  data() {
    return {
      showDrawer: false,
      loading: false,
      syncVoucherCenteLoading: false,
      submitLoading: false,
      isSubmit: false,
      selectedData: [], // 选中项row数据
      selectedIds: [], // 选中项refId数组
      tableData: [],
      onSelectable: (row) => {
        return !this.maxLength || this.selectedIds.length < this.maxLength || this.selectedIds.indexOf(row.refId) >= 0
      }
    };
  },
  created() {
  },
  mounted() {},
  methods: {
  // 同步中台券数据
    async onSyncVoucherCenter(){
      this.showDrawer = true
      this.getTableData()
    },

    // 获取表格数据
    async getTableData() {
      this.loading = true
      this.syncVoucherCenteLoading = true
      const params = {
        ...this.searchForm,
      }
      const data = await api_getVcCardList(params)
      console.log('data: ', data);
      this.tableData = data || []
      data.length != 0 ? this.isSubmit = true : this.isSubmit = false
      this.loading = false
      this.syncVoucherCenteLoading = false
    },

    // 表格单选选择
    selectTable(selection, row) {
      console.log(this.selectedData)
      let curRowIndex = selection.findIndex(item => item.refId == row.refId)
      if (curRowIndex >= 0) {
        // 选择
        this.selectedData.push(row)
      } else {
        // 取消选择
        this.selectedData = this.selectedData.filter(item => item.refId !== row.refId)
      }
      this.selectedIds = this.selectedData.map(item => item.refId)
    },

    // 表格全选选择
    selectTable_all(selection) {
      if (selection.length) {
        // 全选
        let curRow = this.tableData.filter(item => this.selectedIds.indexOf(item.refId) < 0)
        this.selectedData = [...this.selectedData, ...curRow]
      } else {
        // 取消全选
        let curTableIds = this.tableData.map(item => item.refId)
        this.selectedData = this.selectedData.filter(item => curTableIds.indexOf(item.refId) < 0)
      }
      this.selectedIds = this.selectedData.map(item => item.refId)
    },

   async onSubmit(){
      if (this.selectedIds.length==0) {
        this.$baseMessage('请选择需要同步的数据', 'error')
        return
      }
      this.submitLoading = true
      let params = []
      this.selectedData.forEach((item)=>{
        params.push({
          refId: item.refId,
          thirdId: item.thirdId,
        })
      })
      try {
        let res = await api_getVcCardSync(params)
        this.$baseMessage('操作成功', 'success')
        this.$parent.getList()
        this.submitLoading = false
        this.onClose()
      } catch (error) {
        this.submitLoading = false
      }
    },

    onClose(){
      this.selectedData = [] // 选中项row数据
      this.selectedIds = [] // 选中项refId数组
      this.showDrawer = false
    }
  },
};
</script>

<style lang="scss" scoped>
.component-select-card {

  .component-select-box {
    width: 320px;
    height: 34px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #f2f3f5;
    border-radius: 2px;
    border: 1px solrefId #f2f3f5;
    padding: 0 15px;

    &.is-select {
      background-color: #fff;
      border-color: #05C8AF;
    }
    .left {
      display: flex;

      &.placeholder {
        color: #999;
      }
      .tag {
        height: 22px;
        border-radius: 4px;
        border: 1px solrefId #ddd;
        display: flex;
        align-items: center;
        padding: 0 10px;
        color: #999;
        font-size: 12px;
        margin-right: 10px;

        &.select-tag-box {
          .el-icon-error {
            margin-left: 5px;
            font-size: 14px;
            color: #bbb;

            &:hover {
              color: #999;
              cursor: pointer;
            }
          }
        }
      }
    }

    .right {
      .el-icon-arrow-down {
        transform: rotate(0deg);

        &.up {
          transform: rotate(180deg);
        }
      }
    }
  }

  .drawer-box {
    padding: 0 20px;
    height: 90%;
    position: relative;

    .drawer-main-box {
      max-height: calc(100vh - 86px);
      overflow: auto;
    }
    .footer {
    position: fixed;
    bottom: 0;
    padding: 20px 0;
    padding-left: 70px;
    background: #fff;
  }
  }
}
</style>
